import { QueryHookOptions } from '@apollo/client';
import { CountryOption } from '@anytag/shared-types';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, useAllCountriesQuery } from '@anytag/graphql';
import { useTranslateCountryOptions } from './useTranslateOptions';

interface Props extends QueryHookOptions<Query> {
  hasAllCountryOption?: boolean;
  filterFunction?: (country: CountryOption) => boolean;
}

export const useAllCountryOptions = ({ hasAllCountryOption, filterFunction, ...options }: Props = {}) => {
  const { data, loading } = useAllCountriesQuery({ fetchPolicy: 'cache-first', ...options });
  const countries = getSelectOptions(data?.allCountries);
  const allCountries = hasAllCountryOption ? [{ label: 'All', value: '' }, ...countries] : countries;

  return {
    loading,
    allCountryOptions: useTranslateCountryOptions(allCountries),
    filteredCountries: useTranslateCountryOptions(filterFunction ? allCountries.filter(filterFunction) : allCountries)
  };
};
